import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { StripePercentageChartBar, type StripeProgressChartBarItem } from './StripePercentageChartBar.tsx';

type AudienceChartCardProps = {
  items: StripeProgressChartBarItem[];
  title: string;
};

export const AudienceChartCard = ({ items, title }: AudienceChartCardProps) => {
  const displayAudienceChartCard = useMemo(() => {
    return items.filter(item => !(item.percentage === 0 || item.percentage == null)).length !== 0;
  }, [items]);

  return (
    displayAudienceChartCard && (
      <Box
        data-test="audience-distribution-chart"
        sx={{
          border: 1,
          padding: 3,
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            paddingBottom: 1,
            borderBottom: 1,
            marginBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="h3">{title}</Typography>
        </Box>
        <StripePercentageChartBar items={items} />
      </Box>
    )
  );
};
